module.exports = {"apiKey":"ef12de97bf11e262a07c94157ea12429","appVersion":"4.10.0","autoBreadcrumbs":true,"autoCaptureSessions":false,"autoNotify":true,"endpoint":"https://notify.bugsnag.com","interactionBreadcrumbsEnabled":true,"maxBreadcrumbs":40,"maxEvents":10,"notifyReleaseStages":["production","development"],"releaseStage":"development"}


//////////////////
// WEBPACK FOOTER
// ./src/bugsnag.config.json
// module id = 522
// module chunks = 37